/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BatchMoveEtcResponse
 */
export interface BatchMoveEtcResponse {
    /**
     * 
     * @type {string}
     * @memberof BatchMoveEtcResponse
     */
    jobId: string;
}

export function BatchMoveEtcResponseFromJSON(json: any): BatchMoveEtcResponse {
    return BatchMoveEtcResponseFromJSONTyped(json, false);
}

export function BatchMoveEtcResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BatchMoveEtcResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'jobId': json['jobId'],
    };
}

export function BatchMoveEtcResponseToJSON(value?: BatchMoveEtcResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'jobId': value.jobId,
    };
}

